import type { ConfigProviderProps } from 'antd/es/config-provider';

import alert from 'config/theme/components/alert';
import anchor from 'config/theme/components/anchor';
import button from 'config/theme/components/button';
import checkbox from 'config/theme/components/checkbox';
import collapse from 'config/theme/components/collapse';
import datePicker from 'config/theme/components/datePicker';
import drawer from 'config/theme/components/drawer';
import input from 'config/theme/components/input';
import menu from 'config/theme/components/menu';
import modal from 'config/theme/components/modal';
import notification from 'config/theme/components/notification';
import pagination from 'config/theme/components/pagination';
import radio from 'config/theme/components/radio';
import rangePicker from 'config/theme/components/rangePicker';
import select from 'config/theme/components/select';
import table from 'config/theme/components/table';
import tabs from 'config/theme/components/tabs';
import tag from 'config/theme/components/tag';
import textArea from 'config/theme/components/textArea';
import timePicker from 'config/theme/components/timePicker';

const antdComponents: Pick<
  ConfigProviderProps,
  'alert' | 'anchor' | 'button' | 'checkbox' | 'collapse' | 'datePicker' | 'drawer' | 'input' | 'menu' | 'modal'
  | 'notification' | 'pagination' | 'radio' | 'rangePicker' | 'select' | 'table' | 'tabs' | 'tag' | 'textArea' | 'timePicker' | 'virtual'
> = {
  alert,
  anchor,
  button,
  checkbox,
  collapse,
  datePicker,
  drawer,
  input,
  menu,
  modal,
  notification,
  pagination,
  radio,
  rangePicker,
  select,
  table,
  tabs,
  tag,
  textArea,
  timePicker,
  // Select and Listy read this in the app; a per-instance `virtual` prop still wins.
  virtual: false,
};

export default antdComponents;
